import PostTeaser from '../post-teaser'

interface PostTeaserListProps {
  posts: any[]
}

const PostTeaserList = ({ posts }: PostTeaserListProps) => {
  return posts && posts.length ? (
    <ul className="list-unstyled mbxl pbxl">
      {posts.map((post, idx) => (
        <li key={post.id} className={'pbxl'}>
          <PostTeaser post={post} bodyClassName="plm" index={idx} />
        </li>
      ))}
    </ul>
  ) : (
    <p className="mtl">
      There are currently no articles in this category. Check back soon!
    </p>
  )
}

export default PostTeaserList
